'use client';

import { Hit } from 'instantsearch.js';
import Link from 'next/link';

interface EventCardNewProps {
  hit: Hit<any>;
  dict: any;
}

export default function EventCardNew({ hit, dict }: EventCardNewProps) {
  // Extract event data from hit
  const event = hit;
  
  // Helper function to format date
  const formatDate = (dateString: string) => {
    if (!dateString) return { month: 'OCT', day: '7' };
    try {
      const date = new Date(dateString);
      const month = date.toLocaleDateString('en-US', { month: 'short' }).toUpperCase();
      const day = date.getDate();
      return { month, day };
    } catch {
      return { month: 'OCT', day: '7' };
    }
  };

  // Helper function to format time
  const formatTime = (timeString: string) => {
    if (!timeString) return '';
    try {
      const time = new Date(`2000-01-01T${timeString}`);
      return time.toLocaleTimeString('en-US', { 
        hour: 'numeric', 
        minute: '2-digit',
        hour12: true 
      });
    } catch {
      return timeString;
    }
  };

  // Get event image or use default
  const eventImage = event.mainImage || event.banner || '/images/boxes/calender-1.png';
  
  // Get event title
  const eventTitle = event.title || event.name || event.summary || 'Richmond/Philadelphia PADRECC Virtual Parkinson\'s Disease Support Group';
  
  // Get event type/category
  const eventType = event.category || event.type || 'Support group';
  
  // Get event date
  const eventDate = event.date || event.startDate || event.eventDate;
  const { month, day } = formatDate(eventDate);
  
  // Get event time
  const startTime = event.startTime || event.time;
  const endTime = event.endTime;
  const timeRange = startTime ? 
    (endTime ? `${formatTime(startTime)} - ${formatTime(endTime)}` : formatTime(startTime)) : 
    '1:00 - 2:00pm';
  
  // Get event location
  const location = event.location || 
    event.address?.fullAddress || 
    event.contactInformations?.address?.fullAddress ||
    'Statewide';
  
  // Get formatted date string
  const formattedDate = eventDate 
    ? new Date(eventDate).toLocaleDateString('en-US', { 
        weekday: 'long',
        month: 'numeric',
        day: 'numeric',
        year: 'numeric'
      })
    : 'Monday 10/6/2025';

  return (
    <div className="col-lg-4 col-md-6">
      <div className="calender-box">
        <div className="img-box">
          <Link href={`/events/${event.id || event._id || event.objectID}`}>
            <img src={eventImage} alt="" />
          </Link>
          <div className="date">
            <span>{month}</span>
            <span>{day}</span>
          </div>
        </div>
        <div className="text-box">
          <div className="group-box">
            <div className="title">{eventType}</div>
            <div className="supporters">
              {['web-2', 'web-1', 'web-3', 'web-4'].map((icon, j) => (
                <img src={`/images/icons/${icon}.png`} alt="" key={j} />
              ))}
            </div>
          </div>
          <h4>
            <Link href={`/events/${event.id || event._id || event.objectID}`}>
              {eventTitle}
            </Link>
          </h4>
          <div className="detail-box">
            <div className="box">
              <img src="/images/icons/calender.svg" alt="" />
              {formattedDate}
            </div>
            <div className="box">
              <img src="/images/icons/clock.svg" alt="" />
              {timeRange}
            </div>
            <div className="box">
              <img src="/images/icons/loc.svg" alt="" />
              {location}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
